import React, { useEffect, useReducer, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";

import { useSnackbar } from "notistack";
import axios from "axios";
import "./resultuploaddetail.css";
import Logo from "../../../public_directory/public-routes-images/logos/Manga_Cons _Logo2.png";
import IsLoading from "../../../../isLoading";
// import from MUI
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import MailIcon from "@mui/icons-material/Mail";

import SearchIcon from "@mui/icons-material/Search";
import LockResetIcon from "@mui/icons-material/LockReset";

let courses, courseCodeList;
export default function ResultEditDetails() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const redirect = useNavigate();
  const [courseData, setCourseData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      coursecode: "",
      session: "",
      semester: "",
    }
  );
  async function getCoursecodeList() {
    const payload = {
      coursecode: courseData.coursecode,
      session: courseData.session,
      semester: courseData.semester,
    };
    setLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/management/result_upload/fetchCoursesCode`,
        payload
      )
      .then((response) => {
        courses = response.data.courses;
        console.log(courses);
        if (response?.data.status === 201) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "success",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        } else if (response?.data.status === 404) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "error",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        }
        console.log(response);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }
  async function getCourseCodeList() {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/management/result_upload/fetchCoursesCode`
      )
      .then((response) => {
        courseCodeList = response?.data.courseCodes;
        console.log(" course code list", courseCodeList);
        if (response?.data.status === 201) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "success",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        } else if (response?.data.status === 404) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "error",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }

  // CALCULATIONS FOR TOTAL AND GRADE
  // make sure scores is ALWAYS an array
  const [scores, setScores] = useState([]);

  // initialize scores when courses come in
  useEffect(() => {
    if (courses?.length) {
      setScores(courses.map(() => ({ caScore: "", examScore: "" })));
    }
  }, [courses]);

  const handleChange = (index, field, value) => {
    setScores((prevScores) => {
      // fallback to [] if somehow prevScores is not array
      const copy = Array.isArray(prevScores) ? [...prevScores] : [];

      // ensure the index exists
      if (!copy[index]) {
        copy[index] = { caScore: 0, examScore: 0 };
      }

      copy[index][field] = Number(value);
      return copy;
    });
  };

  const handleSubmit = async () => {
    const result = courses.map((course, i) => {
      const ca = scores?.[i]?.caScore || 0;
      const exam = scores?.[i]?.examScore || 0;
      const total = ca + exam;
      const grade =
        total >= 70
          ? "A"
          : total >= 60
          ? "B"
          : total >= 50
          ? "C"
          : // : total >= 45
            // ? "D"
            // : total >= 40
            // ? "E"
            "F";

      return {
        ...course,
        caScore: ca,
        examScore: exam,
        total,
        grade,
      };
    });
    console.log("Sending to DB:", result);
    setLoading(true);
    await axios
      .post(
        `${
          process.env.REACT_APP_SERVER_SCRIPT_HOST
        }/management/result_upload/new_results/postResult/${encodeURIComponent(
          courses[0]?.courseCode
        )}/${encodeURIComponent(courses[0]?.session)}`,
        result
      )
      .then((response) => {
        if (response?.data.status === 201) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "success",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        } else if (response?.data.status === 404) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "error",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getCourseCodeList();
  }, []);
  return (
    <>
      {loading ? (
        <IsLoading />
      ) : (
        <div className="resultUploadPrCont">
          <div className="resultUploadPr fx-cl space1">
            <div className="resultUploadPrHeader fx-ac fx-jc space4">
              <figure>
                <img src={Logo} alt="logo" />
              </figure>
              <div className="fx-cl fx-jc">
                <h2>Aministrative Content Management System</h2>
                <p>Centre for Academic Records and Results Management</p>
                <strong>Student Result Editing Console</strong>
              </div>
            </div>
            <div
              className="fx-cl"
              style={{
                padding: "1rem",
                borderTop: "1px solid #ccc",
                backgroundColor: "transparent",
              }}
            >
              <h3>Course Selection and Result Upload</h3>
              <p>
                Select the course you want to upload result for and click fetch
                course
              </p>
            </div>{" "}
            <div
              className="fx-cl"
              style={{
                backgroundColor: "rgb(217 216 213)",
                padding: "1rem",
                borderRadius: ".8rem",
              }}
            >
              <div className="fx-ac fx-jb space3">
                <div className="fx-ac fx-jc space1">
                  <div
                    className="fx-ac spacem"
                    style={{
                      backgroundColor: "#fff",
                      color: "#666",
                      width: "19rem",
                      padding: "0.4rem 0.8rem",
                      borderRadius: "0.4rem",

                      // cursor: "pointer",
                    }}
                  >
                    <CastForEducationIcon />
                    <select
                      name="coursecode"
                      id=""
                      onChange={(e) =>
                        setCourseData({ coursecode: e.target.value })
                      }
                      value={courseData.coursecode}
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        color: "#666",
                        fontWeight: "bold",
                        width: "100%",
                        cursor: "pointer",
                        fonstSize: "1.2rem",
                      }}
                    >
                      <option value="" disabled hidden>
                        Select course..
                      </option>
                      {courseCodeList?.map((e, i) => (
                        <option key={i} value={e}>
                          {e}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div
                    className="fx-ac spacem"
                    style={{
                      backgroundColor: "#fff",
                      color: "#666",
                      width: "19rem",
                      padding: "0.4rem 0.8rem",
                      borderRadius: "0.4rem",

                      // cursor: "pointer",
                    }}
                  >
                    <CastForEducationIcon />
                    <select
                      name="session"
                      id=""
                      onChange={(e) => {
                        setCourseData({ session: e.target.value });
                      }}
                      value={courseData.session}
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        color: "#666",
                        fontWeight: "bold",
                        width: "100%",
                        cursor: "pointer",
                        fonstSize: "1.2rem",
                      }}
                    >
                      <option value="" disabled hidden>
                        Session..
                      </option>
                      <option value="2024/2025">2024/2025</option>
                      <option value="2025/2026">2025/2026</option>
                    </select>
                  </div>

                  <div
                    className="fx-ac spacem"
                    style={{
                      backgroundColor: "#fff",
                      color: "#666",
                      width: "19rem",
                      padding: "0.4rem 0.8rem",
                      borderRadius: "0.4rem",

                      // cursor: "pointer",
                    }}
                  >
                    <CastForEducationIcon />
                    <select
                      name="semester"
                      id=""
                      onChange={(e) =>
                        setCourseData({ semester: e.target.value })
                      }
                      value={courseData.semester}
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        color: "#666",
                        fontWeight: "bold",
                        width: "100%",
                        cursor: "pointer",
                        fonstSize: "1.2rem",
                      }}
                    >
                      <option value="" hidden>
                        Semester..
                      </option>
                      <option value="First Semester">First</option>
                      <option value="Second Semester">Second</option>
                    </select>
                  </div>
                  <button
                    className="fx-ac spacem"
                    onClick={() => getCoursecodeList()}
                    style={{
                      backgroundColor: "rgb(0, 123, 255)",
                      color: "#fff",
                    }}
                  >
                    <MailIcon />
                    <span>Fetch course</span>
                  </button>
                </div>
              </div>
            </div>
            {courses && (
              <div className="fx-cl space1">
                <div className="resultUploadAside fx-cl space1">
                  <div className="invoice-second-container fx-jb space3">
                    <div className="invoice-inner-div">
                      <div className=" fx-cl space1">
                        <h3>{courses[0]?.courseTitle}</h3>
                        <div className="fx-cl">
                          <p>
                            <strong>Course Code:</strong>{" "}
                            {courses[0]?.courseCode}
                          </p>
                          {/* <p>
                          <strong>Course Title: </strong>
                          {courses[0]?.courseTitle}
                        </p> */}

                          <p>
                            <strong>Unit:</strong> {courses[0]?.creditUnit}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="invoice-inner-div">
                      <div className=" fx-cl space1">
                        <div className="fx-cl">
                          <h3>
                            <span>&nbsp;</span>
                          </h3>

                          <p>
                            <strong>Session:</strong>{" "}
                            {courses[0]?.session || "- - -"}
                          </p>
                          <p>
                            <strong>Semester:</strong> {courses[0]?.semester}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <table className="fx-cl spacem">
                    <thead className="fx-cl spacem">
                      <tr
                        style={{
                          backgroundColor: "rgb(0, 210, 133)",
                          color: "#fff",
                        }}
                      >
                        <th>Adm No.</th>
                        <th>Semester</th>
                        <th>Session</th>
                        <th>Course code</th>
                        <th>CA</th>
                        <th>Exams</th>
                        <th>Total</th>
                        <th>Grade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {courses.map((e, i) => (
                        <tr key={e._id}>
                          <td>{e.student_adm}</td>
                          <td>{e.semester}</td>
                          <td>{e.session}</td>
                          <td>{e.courseCode}</td>

                          <td>
                            <input
                              type="number"
                              value={scores?.[i]?.caScore}
                              onChange={(ev) =>
                                handleChange(i, "caScore", ev.target.value)
                              }
                            />
                          </td>

                          <td>
                            <input
                              type="number"
                              value={scores?.[i]?.examScore}
                              onChange={(ev) =>
                                handleChange(i, "examScore", ev.target.value)
                              }
                            />
                          </td>

                          <td>
                            {(scores?.[i]?.caScore || 0) +
                              (scores?.[i]?.examScore || 0)}
                          </td>

                          <td>
                            <strong>
                              {(() => {
                                const ca = Number(scores?.[i]?.caScore) || 0;
                                const exam =
                                  Number(scores?.[i]?.examScore) || 0;
                                const total = ca + exam;

                                const grade =
                                  total >= 70
                                    ? "A"
                                    : total >= 60
                                    ? "B"
                                    : total >= 50
                                    ? "C"
                                    : total == 0
                                    ? ""
                                    : "F";
                                const getGradeColor = (grade) => {
                                  switch (grade) {
                                    case "A":
                                      return "green";
                                    case "B":
                                      return "blue";
                                    case "C":
                                      return "orange";
                                    default:
                                      return "red"; // F or others
                                  }
                                };
                                return (
                                  <strong
                                    style={{ color: getGradeColor(grade) }}
                                  >
                                    {grade}
                                  </strong>
                                );
                              })()}
                            </strong>
                          </td>
                        </tr>
                      ))}
                    </tbody>

                    {/* <tbody className="fx-cl">
                      {courses.map((e, i) => (
                        <tr key={i}>
                          <td>{e?.student_adm}</td>
                          <td>{e?.semester}</td>
                          <td>{e?.session}</td>
                          <td style={{ textAlign: "left" }}>{e?.courseCode}</td>
                          <td>
                            <input
                              type="number"
                              value={caScore}
                              onChange={(e) => setCaScore(e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              value={examScore}
                              onChange={(e) => setExamScore(e.target.value)}
                            />
                          </td>
                          <td>{total}</td>
                          <td>
                            <strong>
                              {examScore + caScore > 34 ? "C" : "A"}
                            </strong>
                          </td>
                        </tr>
                      ))}
                    </tbody> */}
                  </table>
                </div>
                <div
                  className="fx-cl"
                  style={{
                    backgroundColor: "#f7c9f8ff",
                    padding: "1rem",
                    borderRadius: ".8rem",
                  }}
                >
                  <div className="fx-ac fx-jb space3">
                    <span>&nbsp;</span>

                    <button
                      className="fx-ac spacem"
                      onClick={() => handleSubmit()}
                      style={{
                        backgroundColor: "rgba(255, 0, 98, 1)",
                        color: "#fff",
                      }}
                    >
                      <MailIcon />
                      <span>Submit</span>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
